import React from 'react';
import {logout } from "../firebase";
import { MdOutlineClose } from "react-icons/md"

const closeNav = () => {
  if (document.getElementById("mySidenav")) {
    document.getElementById("mySidenav").style.width = "0";
  }
}

const closeNavAndLogOut = () => {
  logout();
  if (document.getElementById("mySidenav")) {
    document.getElementById("mySidenav").style.width = "0";
  }
}

const SideNav = () => {
  return(
    <div id="mySidenav" className="sidenav">
      <div className=" d-flex justify-content-between">
        <div className="noauth"> </div>
        <h1 className="mt-4">MyRatings</h1>
        {/* <span className="closebtn" onClick={closeNav}>&times;</span> */}
        <MdOutlineClose onClick={closeNav} className="closebtn" />
      </div>
      
      <div className="mainNav">      
        <a href="/dashboard">Ratings</a>
        <a href="/profile">Account</a>
        {/* <a href="#" className="disabled">Friends</a> */}
      </div>
      <div className="secondaryNav mt-5">
        <a href="/privacy">Privacy &amp; Cookie Policy</a>
        <a href="/terms#">Terms and Conditions</a>
        {/* <a href="/contacts">Contact us</a> */}
        <span onClick={closeNavAndLogOut}>Logout</span>
      </div>
      
    </div>
  );
}


export default SideNav;